import DesktopFeaturesPage from 'components/features-page/DesktopFeaturesPage'
import { ReactElement } from 'react'
import type { PageProps } from 'gatsby'

export default function MacOS({ location }: PageProps): ReactElement {
  return <DesktopFeaturesPage path={location.pathname} />
}
